// extracted by mini-css-extract-plugin
export var container = "styles-module--container--YoX2M";
export var video = "styles-module--video--2l8Mi";